(() => {
  'use strict';
  const drawer = document.getElementById('MMCartDrawer');
  const settingsNode = document.getElementById('MMCartDrawerSettings');
  if (!drawer || !settingsNode || drawer.dataset.ready) return;
  drawer.dataset.ready = 'true';
  const { root, strings, bump } = JSON.parse(settingsNode.textContent);
  const items = drawer.querySelector('[data-cart-items]');
  const status = drawer.querySelector('[data-cart-status]');
  const retry = drawer.querySelector('[data-drawer-retry]');
  const checkout = drawer.querySelector('.mm-cart-drawer__checkout');
  const close = drawer.querySelector('[data-cart-close]');
  let pending = false, opener = null, previousOverflow = '', currentCart = null;
  let bumpToggle = null;
  const riceVariantIds = new Set(['67920030171502', '67920030204270']);
  const element = (tag, value, className) => {
    const node = document.createElement(tag);
    if (value !== undefined) node.textContent = value;
    if (className) node.className = className;
    return node;
  };
  const announce = (message, error = false) => {
    status.textContent = message;
    status.setAttribute('role', error ? 'alert' : 'status');
    retry.hidden = !error;
  };
  const loading = value => {
    pending = value;
    drawer.setAttribute('aria-busy', String(value));
    checkout.setAttribute('aria-disabled', String(value));
    if (bumpToggle) bumpToggle.disabled = value;
    items.querySelectorAll('button,input').forEach(node => {
      node.disabled = value || node.dataset.limitDisabled === 'true';
    });
  };
  const updateCounts = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
    drawer.querySelector('[data-drawer-count]').textContent = String(cart.item_count);
    window.dispatchEvent(new CustomEvent('mm:cart-updated', { detail: { cart } }));
  };
  const render = cart => {
    currentCart = cart;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency }).format(cents / 100);
    items.replaceChildren();
    drawer.querySelector('[data-drawer-empty]').hidden = cart.items.length > 0;
    drawer.querySelector('footer').hidden = cart.items.length === 0;
    cart.items.forEach(item => {
      const article = element('article', undefined, 'mm-cart-drawer__item'); article.dataset.lineKey = item.key;
      if (item.image) {
        const image = element('img', undefined, 'mm-cart-drawer__image'); image.src = item.image; image.alt = item.product_title; image.width = 72; image.height = 89; article.append(image);
      } else article.append(element('span', '', 'mm-cart-drawer__image'));
      const info = element('div', undefined, 'mm-cart-drawer__info');
      const title = element('h3', undefined, 'mm-cart-drawer__name'); const link = element('a', item.product_title); link.href = item.url; title.append(link); info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(element('p', item.variant_title, 'mm-cart-drawer__variant'));
      if (item.properties?._lpm_selling_plan || item.selling_plan_allocation) info.append(element('p', strings.subscription, 'mm-cart-drawer__variant'));
      const linePrice = window.MMExternalCheckout?.linePrice(item) ?? item.final_line_price;
      const prices = element('div', undefined, 'mm-cart-drawer__prices'); prices.append(element('span', money(linePrice / item.quantity)), element('strong', money(linePrice))); info.append(prices);
      const actions = element('div', undefined, 'mm-cart-drawer__actions'), quantity = element('div', undefined, 'mm-cart-drawer__quantity');
      const minimum = item.quantity_rule?.min || 1, increment = item.quantity_rule?.increment || 1, maximum = item.quantity_rule?.max;
      const minus = element('button', '-'); minus.type = 'button'; minus.dataset.action = 'minus'; minus.setAttribute('aria-label', strings.decrease + ': ' + item.product_title); minus.dataset.limitDisabled = String(item.quantity <= minimum); minus.disabled = item.quantity <= minimum;
      const input = element('input'); input.type = 'number'; input.min = String(minimum); input.step = String(increment); if (maximum) input.max = String(maximum); input.value = String(item.quantity); input.inputMode = 'numeric'; input.dataset.action = 'quantity'; input.setAttribute('aria-label', strings.quantity + ': ' + item.product_title);
      const plus = element('button', '+'); plus.type = 'button'; plus.dataset.action = 'plus'; plus.setAttribute('aria-label', strings.increase + ': ' + item.product_title); plus.dataset.limitDisabled = String(Boolean(maximum && item.quantity + increment > maximum)); plus.disabled = plus.dataset.limitDisabled === 'true';
      minus.addEventListener('click', () => change(item.key, item.quantity - increment, 'minus'));
      plus.addEventListener('click', () => change(item.key, item.quantity + increment, 'plus'));
      input.addEventListener('change', () => {
        const next = Number(input.value);
        if (!input.reportValidity() || !Number.isSafeInteger(next) || next < minimum || (next - minimum) % increment || (maximum && next > maximum)) { input.value = String(item.quantity); return; }
        change(item.key, next, 'quantity');
      });
      quantity.append(minus, input, plus);
      const remove = element('button', undefined, 'mm-cart-drawer__remove'); remove.type = 'button'; remove.dataset.action = 'remove'; remove.setAttribute('aria-label', strings.remove + ': ' + item.product_title);
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.setAttribute('viewBox', '0 0 18 20'); svg.setAttribute('aria-hidden', 'true'); const path = document.createElementNS('http://www.w3.org/2000/svg', 'path'); path.setAttribute('d', 'M2 5h14M6 5V2h6v3M4 5l1 13h8l1-13M7 8v7M11 8v7'); svg.append(path); remove.append(svg); remove.addEventListener('click', () => change(item.key, 0, 'remove'));
      actions.append(quantity, remove); info.append(actions); article.append(info); items.append(article);
    });
    drawer.querySelector('[data-drawer-currency]').textContent = cart.currency;
    drawer.querySelector('[data-cart-total]').textContent = money(window.MMExternalCheckout?.subtotal(cart) ?? cart.total_price);
    renderBump(cart, money);
    updateCounts(cart);
  };
  const renderBump = (cart, money) => {
    let container = drawer.querySelector('[data-rice-global-bump]');
    if (!container) {
      container = element('div', undefined, 'mm-cart-drawer__bump');
      container.dataset.riceGlobalBump = '';
      items.after(container);
    }
    const entry = bump && window.MMExternalCatalog?.variants?.[String(bump.id)];
    const eligible = cart.items.some(item => riceVariantIds.has(String(item.variant_id)));
    container.hidden = !(eligible && bump?.available && entry?.id && !entry.plan && entry.enabled !== false);
    if (container.hidden) return;
    container.replaceChildren();
    const label = element('label');
    bumpToggle = element('input'); bumpToggle.type = 'checkbox'; bumpToggle.setAttribute('role', 'switch');
    bumpToggle.checked = cart.items.some(item => String(item.variant_id) === String(bump.id) && item.properties?._rice_bump === 'yes');
    bumpToggle.disabled = pending;
    const copy = element('span');
    copy.append(element('strong', 'Add ' + bump.title + ' — ' + money(bump.price)), element('small', 'One-time addition. Not included in recurring refills.'));
    label.append(bumpToggle, copy); container.append(label);
    bumpToggle.addEventListener('change', async () => {
      if (pending) return;
      const accepted = bumpToggle.checked;
      const existing = currentCart.items.find(item => String(item.variant_id) === String(bump.id) && item.properties?._rice_bump === 'yes');
      loading(true); announce(strings.updating);
      try {
        if ((accepted && !existing) || (!accepted && existing)) {
          const path = accepted ? 'cart/add.js' : 'cart/change.js';
          const payload = accepted ? { items: [{ id: bump.id, quantity: 1, properties: { _rice_bump: 'yes' } }] } : { id: existing.key, quantity: 0 };
          const response = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || strings.error);
        }
        const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(strings.load_error);
        render(await response.json()); announce(strings.updated);
      } catch (error) {
        if (bumpToggle) bumpToggle.checked = !accepted;
        announce(error.message || strings.error, true);
      } finally {
        loading(false);
        if (bumpToggle?.isConnected) bumpToggle.focus({ preventScroll: true });
      }
    });
  };
  const load = async () => {
    if (pending) return;
    loading(true); announce(strings.loading);
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(strings.load_error);
      render(await response.json()); announce('');
    } catch (error) { announce(error.message || strings.load_error, true); }
    finally { loading(false); }
  };
  const change = async (key, quantity, action) => {
    if (pending || !Number.isSafeInteger(quantity) || quantity < 0) return;
    loading(true); announce(strings.updating);
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || strings.error);
      render(cart); announce(strings.updated);
      const article = [...items.children].find(node => node.dataset.lineKey === key);
      const nextFocus = article?.querySelector('[data-action="' + action + '"]') || items.querySelector('a') || close;
      loading(false); nextFocus.focus({ preventScroll: true });
    } catch (error) { announce(error.message || strings.error, true); }
    finally { loading(false); }
  };
  const open = trigger => {
    if (!drawer.open) {
      opener = trigger instanceof HTMLElement ? trigger : document.activeElement;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      drawer.showModal(); close.focus();
    }
    load();
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('.mm-cart-link');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); open(link);
  });
  close.addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', event => { if (event.target === drawer) { const bounds = drawer.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close(); } });
  drawer.addEventListener('close', () => { document.body.style.overflow = previousOverflow; if (opener?.isConnected) opener.focus({ preventScroll: true }); });
  retry.addEventListener('click', load);
  window.addEventListener('mm:cart-added', () => open(document.activeElement));
  document.addEventListener('cart:updated', event => { if (event.detail?.cart?.items && !pending) render(event.detail.cart); });
})();
